import { Box, Grid, Skeleton } from '@mui/material';

interface SportsFuturesFeedSkeletonProps {
  showFilters?: boolean;
}

export const SportsFuturesFeedSkeleton = ({
  showFilters = true,
}: SportsFuturesFeedSkeletonProps) => {
  return (
    <Box
      sx={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        minHeight: 0,
      }}
    >
      {/* Category Filters Skeleton */}
      {showFilters && (
        <Box
          sx={{
            display: 'flex',
            gap: 1.5,
            pb: 2,
            pt: 1,
            px: 1,
            flexShrink: 0,
          }}
        >
          {[1, 2, 3, 4, 5].map((i) => (
            <Skeleton
              key={i}
              variant="rounded"
              width={80}
              height={32}
              sx={{ borderRadius: '16px', flexShrink: 0 }}
            />
          ))}
        </Box>
      )}

      {/* Content Skeleton */}
      <Box sx={{ p: 1 }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
          {/* Featured Card Skeleton */}
          <Box
            sx={{
              p: 3,
              bgcolor: 'background.paper',
              borderRadius: 2,
              border: '1px solid',
              borderColor: 'divider',
            }}
          >
            <Skeleton variant="text" width={300} height={40} sx={{ mb: 2 }} />
            {[1, 2, 3].map((i) => (
              <Box key={i} sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
                <Skeleton variant="circular" width={40} height={40} />
                <Skeleton variant="text" width={150} height={24} sx={{ flex: 1 }} />
                <Skeleton variant="text" width={60} height={32} />
                <Skeleton variant="rounded" width={200} height={36} sx={{ borderRadius: 1 }} />
              </Box>
            ))}
          </Box>

          {/* Secondary Grid Skeleton */}
          <Grid container spacing={3}>
            {[1, 2, 3].map((i) => (
              <Grid item xs={12} md={6} lg={4} key={i}>
                <Box
                  sx={{
                    p: 2,
                    bgcolor: 'background.paper',
                    borderRadius: 2,
                    border: '1px solid',
                    borderColor: 'divider',
                    height: '100%',
                  }}
                >
                  <Skeleton variant="text" width={200} height={32} sx={{ mb: 2 }} />
                  {[1, 2, 3].map((j) => (
                    <Box key={j} sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1.5 }}>
                      <Skeleton variant="circular" width={32} height={32} />
                      <Skeleton variant="text" width={100} height={20} sx={{ flex: 1 }} />
                      <Skeleton variant="text" width={40} height={20} />
                    </Box>
                  ))}
                </Box>
              </Grid>
            ))}
          </Grid>

          {/* Global Feed Grid Skeleton */}
          <Grid container spacing={3}>
            {[1, 2, 3, 4].map((i) => (
              <Grid item xs={12} md={6} key={i}>
                <Box
                  sx={{
                    p: 2,
                    bgcolor: 'background.paper',
                    borderRadius: 2,
                    border: '1px solid',
                    borderColor: 'divider',
                  }}
                >
                  <Skeleton variant="text" width={250} height={32} sx={{ mb: 2 }} />
                  {[1, 2, 3].map((j) => (
                    <Box key={j} sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1.5 }}>
                      <Skeleton variant="circular" width={32} height={32} />
                      <Skeleton variant="text" width={120} height={20} sx={{ flex: 1 }} />
                      <Skeleton variant="text" width={50} height={20} />
                    </Box>
                  ))}
                </Box>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Box>
    </Box>
  );
};
